'use client';

import { useEffect, useState } from 'react';
import Image from 'next/image';
import { ImageGalleryWrapper } from './ClientComponentWrappers';

interface ImageSwapperProps {
  initialImage: string;
  altText: string;
  additionalImages: string[];
}

export default function ImageSwapper({ initialImage, altText, additionalImages }: ImageSwapperProps) {
  const [isClient, setIsClient] = useState(false);
  
  useEffect(() => {
    setIsClient(true);
  }, []);
  
  return (
    <>
      {/* Server-side rendered image for better LCP */}
      {!isClient && (
        <div className="relative w-full h-[400px] md:h-[500px] lg:h-[600px] overflow-hidden rounded-lg mb-4">
          <Image
            src={initialImage}
            alt={altText}
            fill
            priority
            fetchPriority="high"
            sizes="(max-width: 768px) 100vw, 50vw"
            className="object-contain"
          />
        </div>
      )}
      
      {/* Client-side image gallery for interactivity */}
      {isClient && (
        <ImageGalleryWrapper
          mainImage={initialImage}
          additionalImages={additionalImages}
        />
      )}
    </>
  );
} 